import { useCallback, useRef, useState } from 'react';
import { useAlarmGroupPlayback } from '../alarm-provider/AlarmGroupProvider';
import AlarmGroupTimeline, {
  AlarmGroupTimelineHandle,
} from './AlarmGroupTimeline';
import TimelineActions from './TimelineActions';

export function AlarmGroupToolbar() {
  const [isCompressedTimeline, setIsCompressedTimeline] = useState(true);
  const [isFetchingNeighbours, setIsFetchingNeighbours] = useState(false);

  const { showMinorAlarms, toggleShowMinorAlarms } = useAlarmGroupPlayback();

  const toggleTimeline = () => setIsCompressedTimeline(!isCompressedTimeline);

  const timelineRef = useRef<AlarmGroupTimelineHandle>(null);

  const onResetZoom = useCallback(() => {
    timelineRef.current?.resetZoom();
  }, []);

  const onNeighbourLoadingChange = useCallback((isLoading: boolean) => {
    setIsFetchingNeighbours(isLoading);
  }, []);

  return (
    <div className="flex flex-col pr-4">
      <TimelineActions
        toggleShowMinorAlarms={toggleShowMinorAlarms}
        showMinorAlarms={showMinorAlarms}
        onResetZoom={onResetZoom}
        isFetchingNeighbours={isFetchingNeighbours}
      />
      <div className="relative mb-10 flex w-full items-center gap-2">
        <div className="flex-grow">
          <AlarmGroupTimeline
            ref={timelineRef}
            isCompressedTimeline={isCompressedTimeline}
            toggleTimeline={toggleTimeline}
            onNeighbourLoadingChange={onNeighbourLoadingChange}
          />
        </div>
      </div>
    </div>
  );
}

export default AlarmGroupToolbar;
